<template>
    <div class="account">
        <div class="action-header">
            <div class="action-header__title">
                {{title}}
            </div>
            <div class="action-header__date-picker">
                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" @change="getChartData" range-separator=" " :formatter="customFormat" v-model="time" :shortcuts="shortcuts" range format="DD/MM/YYYY"></vue-date-picker>
            </div>
        </div>

        <div class="account__graph-container">
            <div class="account__cards-container" v-if="campaignCards && campaignCards.length">
                <div v-for="card in campaignCards" v-on:click="showGraph(card.id)" :key="card.id"
                     v-bind:id="'account-card-'+card.id" v-bind:class="graphActiveCards.includes(card.id) ? card.id : ''" class="account__card card">
                    <div class="card__title">{{card.title}}</div>
                    <div class="card__value">{{card.value}}</div>
                </div>
            </div>

            <div class="account__graph-wrapper">
                <div class="graph-filters">
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'day' }" @click="graph_type = 'day'" href="#">Daily</a>
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'week' }" @click="graph_type = 'week'" href="#">Weekly</a>
                    <a class="graph-filters__item" v-bind:class="{ 'active-filter' : graph_type == 'month' }" @click="graph_type = 'month'" href="#">Monthly</a>
                </div>

                <div class="account__graph">
                    <div style="">
                        <line-chart :styles="{height: '270px', position: 'relative'}" :chart-data="filteredChartData" :options="chartOptions"></line-chart>
                        <div class="graph-footer">
                            <div class="">{{this.leftDate}}</div>
                            <div class="">{{this.rightDate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="account__actions actions">
            <div class="actions__search-container">
                <input @input="applySearch" class="actions__search-input" type="text" v-model="filter.query" placeholder="Search"/>
                <inline-svg
                    class="actions__search-icon"
                    src="/images/search.svg" aria-label="search">
                </inline-svg>
                <inline-svg
                    v-show="filter.query"
                    @click="clearSearch()"
                    class="clear-search"
                    src="/images/clear.svg" aria-label="clear">
                </inline-svg>
            </div>
            <div class="actions__add-filter__wrapper">
                <data-filter @filterApply='applyFilter' v-bind:filtersInit="filtersDataComponent"></data-filter>
            </div>
            <button style="display: none;" type="button" class="actions__add-account">Add Filter</button>
        </div>

        <div class="account__table main-table">
            <table class="main-table__wrapper">
                <thead class="main-table__header">
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'name', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Campaign
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'account_name', 'ASC')" class="table-header-sort noselect">
                        <span>
                          Google Ads account
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'clicks_count', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Ad clicks
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'blocked_count', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Blocked IP
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                <th class="main-table__header-item">
                    <span @click="sortTable($event, 'budged_saved', 'ASC')" class="table-header-sort noselect">
                        <span>
                            Saved budget
                        </span>
                        <span class="sort-col-wrapper">
                            <inline-svg
                                class="sort-icon sort-icon-desc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                            <inline-svg
                                class="sort-icon sort-icon-down sort-icon-asc"
                                src="/images/up-arrow.svg" aria-label="PPCShield">
                            </inline-svg>
                        </span>
                    </span>
                </th>
                </thead>
                <tbody class="main-table__body">
                    <template v-if="isLoadingTableData" >
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="6">
                                <div class="loader">
                                    <svg class="circular" viewBox="25 25 50 50">
                                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="tableData && tableData.length">
                        <tr v-for="item in tableData" class="main-table__row-container">
                            <td @click="getClicks(item.campaign_id, item.campaign_name)" class="main-table__row-item">
                                {{ item.campaign_name }}
                            </td>
                            <td @click="getClicks(item.campaign_id, item.campaign_name)" class="main-table__row-item">
                                {{ item.account_name }}
                            </td>
                            <template v-if="item.clicks == '0' && item.blocks == '0'">
                                <td colspan="3" class="main-table__row-item">
                                    Your campaign is protected. Waiting for clicks...
                                </td>
                            </template>
                            <template v-else>
                                <td @click="getClicks(item.campaign_id, item.campaign_name)" class="main-table__row-item like-link">{{ tableNumber(item.clicks) }}</td>
                                <td @click="getBlocked(item.campaign_id, item.campaign_name)" class="main-table__row-item like-link">{{ tableNumber(item.blocks) }}</td>
                                <template v-if="item.blocks > '0' && item.budged_saved == '0'">
                                    <td class="main-table__row-item">Waiting for CPC from Google Ads</td>
                                </template>
                                <template v-else>
                                    <td @click="getClicks(item.campaign_id, item.campaign_name)" class="main-table__row-item">{{ tableCurrency(item.budged_saved) }}</td>
                                </template>
                            </template>
                        </tr>
                    </template>
                    <template v-else>
                        <tr class="main-table__row-container">
                            <td class="main-table__row-item" colspan="6">Not found</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="pagination-container">
            <span v-if="pages" class="mr-5">Show rows {{page * 20 - 19}} - {{page == pages ? pages_rows : page * 20}} of {{pages_rows}}</span>
            <paginate v-if="pages"
                      :v-model="page"
                      :page-count="pages"
                      :click-handler="getPage"
                      :prev-text="'Prev'"
                      :next-text="'Next'"
                      :container-class="'pagination mb-0'"
                      :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>

<script>
    import {campaignTable} from "../../helpers/campaign-table";
    import {graphCards, graphOptions, tableNumber, tableCurrency} from '../../helpers/graph-cards';
    import {dateShortCuts, defaultDateRange, setCookiesDateRange, dateToString, stringToDate} from "../../helpers/date-converter";
    import Paginate from 'vuejs-paginate';
    import LineChart from './LineChart.js';

    export default {
        name: 'account',
        props: ['account', 'title'],
        components: {
            Paginate,
            LineChart
        },
        data: function () {
            return {
                isLoading: true,
                isLoadingTableData: false,
                tableData: null,
                graphActiveCards: ['saved_budget'],
                graph_type: 'day',
                campaignCards: null,
                pages: null,
                pages_rows: null,
                page: 1,
                filter: {
                    query: '',
                    page: 1,
                    tags: {},
                    account_id: 'null',
                    sort: {
                        'column': '',
                        'sort': '',
                    }
                },
                chartData:[],
                chartOptions: graphOptions,
                time: defaultDateRange(),
                shortcuts: dateShortCuts(),
                filtersDataComponent: null,
                disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
                leftDate: "",
                rightDate: "",
                tableNumber: tableNumber,
                tableCurrency: tableCurrency,
                crutch_for_date_picker: false,
            }
        },
        computed: {
            filteredChartData() {
                const datasets = {
                    saved_budget : {
                        label: "Saved Budget",
                        lineTension:0,
                        borderColor: "#3cba54",
                        backgroundColor: "#3cba54",
                        fill: false,
                        data: [],
                        yAxisID: "saved_budget",
                    },
                    ad_clicks : {
                        label: "Ad Clicks",
                        lineTension:0,
                        borderColor: "#4285f4",
                        backgroundColor: "#4285f4",
                        fill: false,
                        data: [],
                        yAxisID: "ad_clicks",
                    },
                    blocked_ip:{
                        label: "Blocked ip",
                        lineTension:0,
                        borderColor: "#dc4b3e",
                        backgroundColor: "#dc4b3e",
                        fill: false,
                        data: [],
                        yAxisID: "blocked_ip",
                    }
                }

                this.chartData.forEach((row) => {
                    this.graphActiveCards.forEach(key => {
                        datasets[key].data.push(row[key]);
                    })
                })

                let dates = this.chartData.map(i => i.date);
                let values = Object.values(datasets).filter(i => i.data.length > 0);
                let start = moment(dates[dates.length-1]);
                const end = moment(this.time[1]);

                while(start < end){
                    switch (this.graph_type) {
                        case 'day' :
                            start.add(1, 'day');
                            break;
                        case 'week' :
                            start.add(1, 'week');
                            break;
                        case 'month' :
                            start.add(1, 'month');
                            break;
                        default: start.add(1, 'day');
                            break;
                    }
                    dates.push(start.format('MMM DD, YYYY'));
                    values.forEach(element => {
                        element.data.push(0);
                    });
                }

                dates = dates.map(i => moment(i).format('MMM DD, YYYY'));

                if (moment(dates[dates.length-1]) > end) {
                    dates.pop();
                }

                this.leftDate = dates[0];
                this.rightDate = dates[dates.length-1];
                dates[0] = "";
                dates[dates.length-1] = "";

                return {
                    labels: dates,
                    datasets: values,
                }
            },
            customFormat() {
                return {
                    stringify: (date) => {
                        if(moment(this.time[1]).format('L') === moment(this.time[0]).format('L')){
                            if(!this.crutch_for_date_picker){
                                this.crutch_for_date_picker = true;
                            }
                            else  {
                                this.crutch_for_date_picker = false;
                            }
                            return date
                                ? this.crutch_for_date_picker
                                    ? moment(date).format('L') === moment(this.time[0]).format('L')
                                        ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                        : ''
                                    : ''
                                : ''
                        }
                        else{
                            return date
                                ? moment(date).format('L') === moment(this.time[0]).format('L')
                                    ? dateToString(moment(this.time[0]).format('MMM D YYYY'), moment(this.time[1]).format('MMM D YYYY'))
                                    : ''
                                : ''
                        }
                    },
                    parse: (value) => {
                        return value
                            ? this.calcDateFormatToDate()
                            : null
                    },
                }
            }
        },
        methods: {
            calcDateFormatToDate(){
                let stringDate = $('.action-header__date-picker .mx-input-wrapper input').val();
                let tempTime = stringToDate(stringDate);
                if(tempTime[0].isValid() &&
                    tempTime[1].isValid() &&
                    (moment(this.time[0]).format('MMM D YYYY') !== moment(tempTime[0]).format('MMM D YYYY') ||
                        moment(this.time[1]).format('MMM D YYYY') !== moment(tempTime[1]).format('MMM D YYYY')))
                {
                    this.time = [tempTime[0].toDate(), tempTime[1].toDate()];
                    this.getChartData();
                }
                return null;
            },
            sortTable(event, column, type) {
                $(".sort-icon").removeClass("active-sort");
                let element = $(event.currentTarget);
                if(column === this.filter.sort.column) {
                    if(this.filter.sort.type === 'ASC') {
                        type = 'DESC';
                        $(element).find(".sort-icon-asc").addClass("active-sort");
                    }
                    else if(this.filter.sort.type === 'DESC') {
                        type = '';
                    }
                    else {
                        type = 'ASC';
                        $(element).find(".sort-icon-desc").addClass("active-sort");
                    }
                } else {
                    $(element).find(".sort-icon-desc").addClass("active-sort");
                }
                this.filter.sort.column = column;
                if(type === '') this.filter.sort.column = '';
                this.filter.sort.type = type;
                this.getCampaignData();
            },
            getChartData() {
                this.isLoading = true;
                axios.get('account/chart',
                    {
                        params: {
                            date_from: this.time[0] ? moment(this.time[0]).format() : '',
                            date_to: this.time[1] ? moment(this.time[1]).format('') : '',
                            chart_type: this.graph_type,
                            accounts: [this.filter.account_id],
                            //timezone: new Date().getTimezoneOffset(),
                        }
                    })
                    .then(info => {
                        this.isLoading = false;
                        this.chartData = info.data.data;
                        if(this.chartData.length === 1) this.chartData.push(this.chartData[0]);
                        this.campaignCards = graphCards(info.data.summary);
                    })
                    .catch(err => {
                        this.isLoading = false;
                        console.log('err', err);
                    });
            },
            graphFilter(e, filter_type) {
                let elements = document.querySelectorAll(".graph-filters__item");
                [].forEach.call(elements, function(el) {
                    el.classList.remove("active-filter");
                });

                e.currentTarget.classList.add('active-filter');
                this.getChartData(filter_type);
            },
            showGraph(graph_id = '') {
                if (graph_id !== '') {
                    const index = this.graphActiveCards.indexOf(graph_id);
                    if (index > -1) {
                        this.graphActiveCards.splice(index, 1);
                    } else {
                        this.graphActiveCards.push(graph_id);
                    }
                }
                $("#account-graph").show();
            },
            clearSearch() {
                this.filter.query = '';
                this.getCampaignData();
            },
            getCampaignData() {
                const last_search_value = this.filter.query;
                if(this.isLoadingTableData) return;
                this.isLoadingTableData = true;
                this.filter.account_id = this.account;
                axios.get('campaign/total', {
                    params: {
                        query: this.filter.query,
                        page: this.filter.page,
                        account: this.filter.account_id,
                        column: this.filter.sort.column,
                        type: this.filter.sort.type,
                        date_from: this.time[0] ? moment(this.time[0]).format() : '',
                        date_to: this.time[1] ? moment(this.time[1]).format() : '',
                        filters: this.filter.tags,
                        //timezone: new Date().getTimezoneOffset(),
                    }
                })
                    .then(info => {
                        this.isLoadingTableData = false;
                        if(last_search_value === this.filter.query){
                            const {data: {items = []}} = info;
                            this.tableData = campaignTable(items);
                            this.pages_rows = info.data.total_rows;
                            this.pages = info.data.total;
                        }
                        else{
                            this.getCampaignData();
                        }
                    })
                    .catch(err => {
                        this.isLoadingTableData = false;
                        console.log('err', err);
                    });
            },
            getFiltersData() {
                axios.get('campaign/totalled', {
                        params: {account: this.filter.account_id}
                    })
                    .then(info => {
                        this.filtersDataComponent = info.data.items;
                    })
                    .catch(err => console.log('err', err));
            },
            applySearch() {
                this.page = 1;
                this.filter.page = 1;
                this.getCampaignData();
            },
            applyFilter(data) {
                this.filter.tags = data.filter_data;
                this.page = 1;
                this.filter.page = 1;
                this.getCampaignData();
            },
            getPage: function (pageNum) {
                this.page = pageNum;
                this.filter.page = pageNum;
                this.getCampaignData()
            },
            getClicks: function (campaign_id, campaign) {
                window.location.href = '/clicks?campaign_id='+campaign_id+'&campaign='+campaign;
            },
            getBlocked: function (campaign_id, campaign) {
                window.location.href = '/blocked?campaign_id='+campaign_id+'&campaign='+campaign;
            },
            setAllTimeDatePicker(){
                axios.get('/account/getStartAllTimeDate')
                    .then(response => {
                        this.shortcuts = dateShortCuts(response.data);
                    });
            },
        },
        mounted() {
            this.setAllTimeDatePicker();
            this.getCampaignData();
            this.getChartData();
            this.getFiltersData();
        },
        watch: {
            time: function(val) {
                setCookiesDateRange(val[0], val[1]);
                this.getCampaignData();
            },
            graph_type: function () {
                this.getChartData();
            }
        }
    }
</script>
